// default products. they should be in the database, but could possibly not be.
export enum ProgressProductCode {
    DesignForSuccession = "DFS",
    DesignResilientBusiness = "DRB",
}

export class ProgressProductCodeMetadata {
    public static readonly DesignForSuccession = new ProgressProductCodeMetadata(
        ProgressProductCode.DesignForSuccession,
        "Design for succession",
        ["#757575"]);
    public static readonly DesignResilientBusiness = new ProgressProductCodeMetadata(
        ProgressProductCode.DesignResilientBusiness,
        "Design your resilient business",
        ["#e2445c", "#ffcb00", "#9cd326", "#7f5347"]);

    public static readonly ByCode: { [status in ProgressProductCode]: ProgressProductCodeMetadata } = {
        [ProgressProductCode.DesignForSuccession]: ProgressProductCodeMetadata.DesignForSuccession,
        [ProgressProductCode.DesignResilientBusiness]: ProgressProductCodeMetadata.DesignResilientBusiness,
    };

    private constructor(
        public readonly code: ProgressProductCode,
        public readonly name: string,
        public readonly categoryColours: string[],
    ) { }
}
